import React, {Component, Fragment} from 'react';
import {Button, Card, CardBody, CardTitle, Row} from 'reactstrap';
import {withTranslation} from 'react-i18next';
import {Colxx, Separator} from '../../../../components/common/CustomBootstrap';
import moment from 'moment';
import {
  i18nizeDate,
  numberWithCommas,
  getStatusColor,
  mapStatus,
} from '../../../../helpers/Utils';
import {baseTokenSymbol, fetchIntervalTime, reactTableText} from '../../../../constants/configs';
import ModalManager from '../../../../components/modal/ModalManager';
import Breadcrumb from '../../../../containers/navs/Breadcrumb';
import ReactTableSelectFilter from '../../../../components/ReactTableSelectFilter';
import ReactTableDateFilter from '../../../../components/ReactTableDateFilter';
import ReactTableTextFilter from '../../../../components/ReactTableTextFilter';
import BankDepositFeedbackForm from "../../../../containers/BankDepositFeedbackForm";
import {NotificationManager} from "../../../../components/common/react-notifications";
import BankPaymentDetails from "../../../../containers/BankPaymentDetails";
import ToolTip from '../../../../components/ToolTip';
import {keyBy, mapValues, omit} from 'lodash';
import Api from '../../../../services/Api';
import {Link} from 'react-router-dom';
import ReactTable from 'react-table';
import Zoom from "react-medium-image-zoom";
import Rbac from "../../../../components/Rbac";

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      deposits: [],
      pages: -1,
      loading: false,
      selectedStartDate: null,
      selectedEndDate: null,
      expanded: {},
    };
    this.renderStatusFilter = this.renderStatusFilter.bind(this);
    this.renderDateFilter = this.renderDateFilter.bind(this);
    this.renderImageCell = this.renderImageCell.bind(this);
  }

  async componentDidMount() {
    this.interval = setInterval(async () => {await this.fetchDeposits(this.table.state);}, fetchIntervalTime);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  fetchData = async state => {
    this.setState({loading: true});
    await this.fetchDeposits(state);
    this.setState({loading: false});
  };

  fetchDeposits = async state => {
    try {
      const offset = state.page * state.pageSize;
      const {data} = await Api.invoke(
        'GET',
        '/v2/admin-ui/deposits/bankPayments',
        null,
        {
          params: {
            offset,
            limit: state.pageSize,
            ...(state.filtered.length ? omit(mapValues(keyBy(state.filtered, 'id'), 'value'), 'createdAt') : null),
            ...(this.state.selectedStartDate ? {from: moment(this.state.selectedStartDate).toISOString()} : null),
            ...(this.state.selectedEndDate ? {to: moment(this.state.selectedEndDate).toISOString()} : null),
          },
        },
      );
      this.setState({
        deposits: data.rows,
        pages: Math.ceil(data.count / state.pageSize),
      });
    } catch (e) {
      console.log('error: ', e);
    }
  };

  confirmPayment = async paymentId => {
    const {t} = this.props;
    try {
      await Api.invoke('PATCH', `/v2/admin-ui/deposits/bankPayments/${paymentId}`, {
        status: 'CONFIRMED',
      });
      NotificationManager.success(t('Bank payment confirmed successfully'), t('Message'));
      await this.fetchDeposits(this.table.state);
    } catch (e) {
      console.log("error: ", e);
    }
  };

  getColumns = t => [
    {
      Header: t('First Name'),
      accessor: 'user.firstName',
      filterable: true,
      Filter: ReactTableTextFilter,
    },
    {
      Header: t('Last Name'),
      accessor: 'user.lastName',
      filterable: true,
      Filter: ReactTableTextFilter,
    },
    {
      Header: t('Email'),
      accessor: 'user.email',
      filterable: true,
      Filter: ReactTableTextFilter,
      minWidth: 200,
    },
    {
      Header: t('Payment Code'),
      accessor: 'receiptCode',
      filterable: true,
      Filter: ReactTableTextFilter,
    },
    {
      Header: t('Slip Image'),
      accessor: 'receipt',
      Cell: this.renderImageCell,
    },
    {
      Header: `${t('Amount')} (${t(baseTokenSymbol)})`,
      accessor: 'amount',
      Cell: props => <span>{numberWithCommas(Number(props.value))}</span>,
    },
    {
      Header: t('Status'),
      accessor: 'status',
      filterable: true,
      Filter: this.renderStatusFilter,
      Cell: props => <span className={getStatusColor(props.value)}>{mapStatus(props.value)}</span>,
    },
    {
      Header: t('Date'),
      accessor: 'createdAt',
      width: 160,
      Cell: props => <span>{i18nizeDate(props.value)}</span>,
      filterable: true,
      Filter: this.renderDateFilter,
    },
    {
      Header: t('Actions'),
      accessor: 'id',
      width: 120,
      Cell: props =>
        <div className='d-flex flex-row align-items-center justify-content-around'>
          <Rbac permission='update_bank-deposit'>
            <ToolTip id={`confirm_${props.original.userId}`} text={t('Confirm Deposit')}>
              <i className="icon-Yes text-success text-one font-weight-bold cursor-pointer" onClick={() => {this.onPressConfirm(props.value);}}/>
            </ToolTip>
          </Rbac>
          <Rbac permission='update_bank-deposit'>
            <ToolTip id={`reject_${props.original.userId}`} text={t('Reject Deposit')}>
              <i className="icon-Close text-danger text-one font-weight-bold cursor-pointer"
                 onClick={() => {this.showBankDepositFeedbackForm('SUBMIT', props.original);}}/>
            </ToolTip>
          </Rbac>
          <ToolTip id={`view_${props.original.userId}`} text={t('View Profile')}>
            <Link to={{
              pathname: '/dashboard/users/' + props.original.user.id,
            }}>
              <i className="simple-icon-eye view-icon text-large"/>
            </Link>
          </ToolTip>
        </div>,
    },
  ];

  onPressConfirm = paymentId => {
    const {t} = this.props;
    ModalManager.open({
      isOpen: true,
      title: t('Confirm Deposit'),
      body: t('Are you sure you want to confirm this payment ?'),
      buttons: [
        {
          color: 'primary',
          onClick: async () => {
            await this.confirmPayment(paymentId);
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('Accept'),
        },
        {
          color: 'grey',
          onClick: () => {
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('Close'),
        },
      ],
    });
  };

  showBankDepositFeedbackForm = (type, transaction) => {
    const {t} = this.props;
    const {id, rejectReason} = transaction;
    ModalManager.open({
      isOpen: true,
      title: t('Rejection Reason'),
      body: <BankDepositFeedbackForm
        type={type}
        paymentId={id}
        rejectReason={rejectReason}
        afterSubmit={async () => {await this.fetchDeposits(this.table.state);}}
      />,
    });
  };

  renderImageCell(props) {
    if (props.value) {
      const {id} = props.original;
      return (
        <div className='d-flex flex-row align-items-center justify-content-around'>
          <div key={id}>
            <img
              onClick={() => {
                const {firstName, lastName} = props.original.user;
                ModalManager.open({
                  size: 'lg',
                  isOpen: true,
                  title: `${firstName} ${lastName}`,
                  body:
                    <Zoom><img src={props.value} width="100%" height="100%"/></Zoom>,
                });
              }}
              src={props.value}
              height={40}
              width={40}
            />
          </div>
        </div>
      );
    }
    return null;
  }

  renderStatusFilter({filter, onChange}) {
    const {t} = this.props;
    const options = [
      {value: '', label: t('all')},
      {value: 'SUBMITTED', label: t('Submitted')},
      {value: 'CONFIRMED', label: t('Confirmed')},
      {value: 'REJECTED', label: t('Rejected')},
    ];
    return <ReactTableSelectFilter
      filter={filter}
      onChange={onChange}
      options={options}
    />;
  }

  renderDateFilter({onChange}) {
    const {selectedStartDate, selectedEndDate} = this.state;
    return <ReactTableDateFilter
      onChange={onChange}
      handleDateChange={this.handleDateChange}
      selectedStartDate={selectedStartDate}
      selectedEndDate={selectedEndDate}
    />;
  }

  handleDateChange = (type, date) => {
    this.setState({
      [type]: date,
    });
  };

  onExpanded = (newExpanded, index) => {
    this.setState({
      expanded: {
        ...this.state.expanded,
        [index[0]]: !!newExpanded[index[0]],
      },
    });
  };

  render() {
    const {t, match} = this.props;
    const {deposits, pages, loading, expanded} = this.state;
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb match={match}/>
            <Separator className="mb-5"/>
          </Colxx>
        </Row>
        <Row>
          <Colxx xxs="12" className="mb-4">
            <Card className="h-100">
              <CardBody>
                <CardTitle className="d-flex flex-row justify-content-end align-items-center">
                  <Button
                    outline
                    className="d-flex align-items-center justify-content-center"
                    onClick={() => {}}>
                    <i className="icon-File-Excel text-large"/>
                    <span className="mx-1">{t('Excel output')}</span>
                  </Button>
                </CardTitle>
                <ReactTable
                  manual
                  ref={el => {this.table = el;}}
                  className="-highlight"
                  data={deposits}
                  pages={pages}
                  loading={loading}
                  sortable={false}
                  resizable={true}
                  expanded={expanded}
                  defaultPageSize={25}
                  style={{width: '100%'}}
                  onFetchData={this.fetchData}
                  columns={this.getColumns(t)}
                  onExpandedChange={this.onExpanded}
                  onPageChange={() => {this.setState({expanded: {}});}}
                  SubComponent={({original}) =>
                    <BankPaymentDetails
                      transaction={original}
                      showBankDepositFeedbackForm={this.showBankDepositFeedbackForm}
                    />
                  }
                  {...reactTableText}
                />
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      </Fragment>
    );
  }
}

export default withTranslation()(List);
